<template>
  <div class="fixed-aside-box">
    <!-- <div class="aside-item wechat">
      <div class="aside-imgs"></div>
      <div class="aside-txt">微信</div>
      <div class="position-sub">
        <div class="position-img"></div>
      </div>
    </div> -->
    <div class="aside-item phone">
      <div class="aside-imgs"></div>
      <div class="aside-txt">服务<br />咨询</div>
      <div class="position-sub">
        <div class="sub-box"> 
          <div class="sub-txt">
            <span class="name">王老师</span><span class="phone">13161510966</span>
          </div>
          <!-- <div class="sub-img">
            <img class="imgs" src="../../../assets/site/home/wang.jpg" />
          </div> -->
        </div>
      </div>
    </div>
    <div class="aside-item try" @click="goToNeed">
      <div class="aside-imgs"></div>
      <div class="aside-txt">免费<br />试用</div>
    </div>
    <div class="aside-item down" @click="backtop">
      <div class="aside-imgs"></div>
      <div class="aside-txt">回到<br />顶部</div>
    </div>
  </div>
</template>

<script>
import services from '../../../config/services';
export default {
  name: "Aside",
  components: {},
  data () {
    return {}
  },
  methods: {
    backtop () {
      var timer = setInterval(function () {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30)
    },
    goToNeed () {
      window.open(`${services.YXT_GW}/need`)
    }
  }
}
</script>

<style scoped>
.fixed-aside-box {
    position: fixed;
    top: 50%;
    right: 0;
    z-index: 100;
    width: 55px;
    transform: translate(0, -50%);
    background: #ffffff;
    /* border: 1px solid #F5F7FA; */
    box-shadow: 0px 0px 8px 0px rgba(83, 83, 83, 0.2);
    border-radius: 4px;
}
.aside-item {
    background-color: #fff;
    height: 60px;
    text-align: center;
    cursor: pointer;
    position: relative;
}
.aside-item .aside-imgs {
    width: 100%;
    height: 60px;
    margin: 0 auto;
}
.aside-item .aside-txt {
    display: none;
    height: 60px;
    text-align: center;
}
.aside-item:hover {
    background: #f9e3e1;
}
.aside-item:hover .aside-txt {
    color: #df4233;
    display: flex;
    align-items: center;
    justify-content: center;
}
.aside-item:hover .aside-imgs {
    display: none;
}
.aside-item.wechat {
    border-radius: 4px 4px 0 0;
}
.aside-item.wechat .aside-imgs {
    background: url('../../../assets/common/wechat.png') no-repeat center;
    background-size: 22px auto;
}
.aside-item.phone .aside-imgs {
    background: url('../../../assets/common/telephone.png') no-repeat center;
    background-size: 22px auto;
}
.aside-item.try .aside-imgs {
    background: url('../../../assets/common/free-icon.png') no-repeat center;
    background-size: 22px auto;
}
.aside-item.down .aside-imgs {
    background: url('../../../assets/common/back-icon.png') no-repeat center;
    background-size: 22px auto;
}
.aside-item.down {
    border-radius: 0 0 4px 4px;
}
.aside-txt {
    font-size: 12px;
    color: #939292;
}
.position-sub {
    position: absolute;
    left: 0;
    top: -10px;
    padding: 15px;
    background-color: #fff;
    display: none;
    box-shadow: 0px 0px 7px 1px rgba(61, 119, 255, 0.12);
    border-radius: 8px 0 0 8px;
}
.position-sub.phone::after {
    width: 8px;
    height: 100%;
    content: '';
    display: inline-block;
    position: absolute;
    right: -4px;
    top: 0;
    z-index: 20;
    box-shadow: 0px 0px 8px 0px rgba(83, 83, 83, 0.2);
    border-radius: 4px;
}
.aside-item.wechat:hover .position-sub {
    display: block;
    left: -96px;
    top: 0;
    padding: 0px;
}
.position-sub .sub-box {
  width: 100%;
  display: flex;
}
.position-sub .sub-box .sub-txt {
  margin-right: 15px;
  text-align: left;
}
.position-sub .sub-box .sub-txt .name {
  font-weight: bold;
  font-size: 16px;
  color: #212224;
  display: block;
  margin: 15px 0;
}
.position-sub .sub-box .sub-txt .phone {
  font-weight: 400;
  font-size: 14px;
  color: #2B2C2E;
  border-bottom: 6px solid #EFF6FF;
}
.position-sub .sub-box .sub-img  img{
  width: 90px;
  height: auto;
}
.aside-item.wechat .position-sub .position-img {
    width: 96px;
    height: 96px;
    background: url('../../../assets/common/erweima-md.png') no-repeat center;
    background-size: 100% auto;
}
.aside-item.phone:hover .position-sub {
    display: block;
    left: -125px;
    top: 0;
    padding: 15px;
}

.aside-item.phone .position-sub .position-txt {
    font-size: 14px;
    font-weight: bold;
    color: #6f6e6e;
    line-height: 30px;
}
</style>